import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { LookupApi } from "../../../shared/nestjs/gd-only/services/lookup.api";



@Injectable()
export class LookupBloc {
  constructor(
    public lookupApi: LookupApi
  ) {

   }
  
  country(): Observable<any> {
    console.log('BLOC | country')
		return this.lookupApi.country();
  }
  
  state(countryId): Observable<any> {
    console.log('BLOC | state', countryId)
		return this.lookupApi.state(countryId);
  }
  
  city(stateId): Observable<any> {
    console.log('BLOC | city', stateId)
		return this.lookupApi.city(stateId);
  }

  district(cityId): Observable<any> {
    console.log('BLOC | cityId', cityId)
		return this.lookupApi.district(cityId);
  }
  
  subdistrict(districtId): Observable<any> {
    console.log('BLOC | subdistrict', districtId)
		return this.lookupApi.subdistrict(districtId);
  }
  
  statusliving(): Observable<any> {
		return this.lookupApi.statusliving();
  }

  statusowner(): Observable<any> {
		return this.lookupApi.statusowner();
  }

  educationLevel(): Observable<any> {
		return this.lookupApi.educationLevel();
  }

  educationalInstitution(status): Observable<any> {
    console.log('BLOC refMajor', status)
		return this.lookupApi.educationalInstitution(status);
  }

  refFaculty(): Observable<any> {
		return this.lookupApi.refFaculty();
  }

  refMajor(status): Observable<any> {
    console.log('BLOC refMajor', status)
		return this.lookupApi.refMajor(status);
  }

  refBloodType(): Observable<any> {
		return this.lookupApi.refBloodType();
  }

  familyRelationship(): Observable<any> {
		return this.lookupApi.familyRelationship();
  }

  refClothSize(): Observable<any> {
		return this.lookupApi.refClothSize();
  }

  refResignReason(): Observable<any> {
		return this.lookupApi.refResignReason();
  }

  refLineOfBusiness(): Observable<any> {
		return this.lookupApi.refLineOfBusiness();
  }

  refDisability(): Observable<any> {
		return this.lookupApi.refDisability();
  }

  refCurrency(): Observable<any> {
		return this.lookupApi.refCurrency();
  }

  allCity(): Observable<any> {
		return this.lookupApi.allCity();
  }

  allState(): Observable<any> {
		return this.lookupApi.allState();
  }

  allDistrict(): Observable<any> {
		return this.lookupApi.allDistrict();
  }

  allSubdistrict(obj): Observable<any> {
    console.log('BLOC', obj, obj.subdistrictId)
		return this.lookupApi.allSubdistrict(obj);
  }

  companyGroup(): Observable<any> {
		return this.lookupApi.companyGroup();
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/lookup.bloc.ts